import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { t } from '../locale';

interface QrCodeHelpButtonProps {
    onClick: () => void;
}

export default function QrCodeHelpButton({ onClick }: QrCodeHelpButtonProps) {
    return (
        <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='qr-tooltip'>{t('qrCodeTooltip')}</Tooltip>}
        >
            <button
                className='btn btn-sm btn-outline-primary rounded-pill'
                type='button'
                onClick={onClick}
            >
                <i className='bi bi-qr-code me-1' />
            </button>
        </OverlayTrigger>
    );
}